// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:17:38+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            32fe3f917217b3d46bacc700f371322d
//    Signature:      eyJpdiI6InNaNDZGYjhBeTFNWHlTaXpsaVwvbWtBPT0iLCJ2YWx1ZSI6IlBtTkt0QWRqNVErdGJhXC9oNDlYTFBEbUF2U3FSR1FYVXU3NVJ6Wk5VaVVhSmkyZ0NSeFRXNUpaXC9iRHNsSE16NjBieDcydDU5ZlA4WDNlRloybEY5WlczcFNERG8wVzJGdXpWc3BWaG1kUmlTNzVBRHJoRmtQMlluclo0dTlDbVlNQU5PMW91dkREbzVVcXJMUk1TOERVN2ZPTHJURGhWSlpoSk9VMzhHSUoyaE80eXJVQmpzeFwvNkVydkhZNTZnVkl1UHRheG5KTHVESHdIaTN5aWVHY2VGK2xxdXM0Wjg0SEJhd2tmeTZRdjMxeXRDMldZSndncUUzaSttUURueG0rSDkwZjcrUVZcL0k1aDErTUtya3V6NnRtXC8xTmxCWU8wMndYVWdxVnZyQlU5TlFNalwvdUlvUEJLUzhzWkNvMm5EWnZYRXVIUWh3Nm1SRjBpSW5SWCtFdndSK2k3TjdmNGl6VGsxYStoRm5xZXE3UFwvaVZJV291OFNGV01GZDQ0T0w2dG1sRm43SEdBMnJpRXZwMWhCMEtBPT0iLCJtYWMiOiJhY2QxMzdhMmQ2NTZjMjQ4NTg4OTQ5MzIxZGVlNTdhNDI1NmRjYTA2MTZiMjZhNzJkNDc4YmE4ODc2MDIyYTIxIn0=
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
